module.exports = __webpack_public_path__ + "static/media/hw_no_25.0ba2b580.flv";